<template>
    <div>        
        <div class="form-row justify-content-start">
            <div class="col-sm-4">
                <base-input :disabled="isOwnerFieldsDisabled" required label="CPF / CNPJ" type="tel" placeholder="" v-model="value.document" v-validate="modelValidations.document" data-vv-name="bankAccount.document" data-vv-as="cpf/cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :error="getError('bankAccount.document')" />
            </div>  
            <div class="col-sm-6">
                <base-input :disabled="isOwnerFieldsDisabled" type="text" label="Titular" required placeholder="" v-model="value.owner" v-validate="modelValidations.owner" data-vv-name="bankAccount.owner" data-vv-as="titular" maxlength="255" :error="getError('bankAccount.owner')" />
            </div>                                                              
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-3 col-md-6">
                <div class="form-group">
                    <label for="name">E-mail PagBank</label>
                    <input :disabled="$auth.isSalesPerson || disabled" type="email" placeholder="Digite seu e-mail" v-model="value.pagBankEmail" v-validate="modelValidations.pagBankEmail" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.pagBankEmail')}" data-vv-name="bankAccount.pagBankEmail" data-vv-as="e-mail PagBank" maxlength="255" />
                    <div v-show="errors.has('bankAccount.pagBankEmail')" class="invalid-feedback">
                        {{ errors.first('bankAccount.pagBankEmail') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-3 col-md-4">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Banco</label>
                    <select :disabled="$auth.isSalesPerson || disabled" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.bankCode')}" v-validate="modelValidations.bankCode" v-model="value.bankCode" data-vv-name="bankAccount.bankCode" data-vv-as="banco">
                        <option v-for="(s, index) in bankList" :key="index" :value="s.COMPE" v-text="s.COMPE == null ? s.LongName : `${s.COMPE} - ${s.LongName}`"></option>
                    </select>
                    <div v-show="errors.has('bankAccount.bankCode')" class="invalid-feedback">
                        {{ errors.first('bankAccount.bankCode') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-2">
                <base-input :disabled="$auth.isSalesPerson || disabled" required label="Agencia (sem digito)" type="tel" placeholder="" v-model="value.branchNumber" v-validate="modelValidations.branchNumber" data-vv-name="bankAccount.branchNumber" data-vv-as="agência" maxlength="4" :error="getError('bankAccount.branchNumber')" />
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="name">Conta</label>                                    
                    <the-mask :disabled="$auth.isSalesPerson || disabled" required type="tel" placeholder="" v-model="value.number" v-validate="modelValidations.number" data-vv-name="bankAccount.number" data-vv-as="conta-corrente" maxlength="14" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.number')}" :mask="['#####-#', '######-#', '#######-#', '########-#', '#########-#', '##########-#', '###########-#', '############-#']" />
                    <div v-show="errors.has('bankAccount.number')" class="invalid-feedback">
                        {{ errors.first('bankAccount.number') }}
                    </div>
                </div>                
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Tipo</label>
                    <select :disabled="$auth.isSalesPerson || disabled" :class="{'form-control': true, 'is-invalid': errors.has('bankAccount.type')}" v-validate="modelValidations.type" v-model="value.type" data-vv-name="bankAccount.type" data-vv-as="tipo">
                        <option v-for="(s, index) in bankAccountTypeList" :key="index" :value="s.value">
                            {{s.text}}
                        </option>
                    </select>
                    <div v-show="errors.has('bankAccount.type')" class="invalid-feedback">
                        {{ errors.first('bankAccount.type') }}
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
import helperService from '../../services/Helper/helperService'
import eventbus from '../../eventBus'
export default {
    name: 'bank-account',
    inject: ['$validator'],
    props: {
        value: {
            type: Object,
            default: {
                owner: '',
                document: '',
                number: '',
                branchNumber: '',
                documentType: '',
                bankCode: null,
                type: null,
                pagBankEmail: '',
                customerId: '',
                status: 'ACTIVE'
            }
        },
        action: {
            type: String
        },
        disabled: {
            type: Boolean
        }
    },
    data() {
        return {
            modelValidations: {
                owner: {
                    required: this.$auth.isSalesPerson ? false : true
                },
                document: {
                    required: this.$auth.isSalesPerson ? false :  true
                },
                number: {
                    required: this.$auth.isSalesPerson ? false :  true,
                    min: 6,
                    max: 13
                },
                branchNumber: {
                    required: this.$auth.isSalesPerson ? false :  true,
                    max: 10
                },
                documentType: {
                    required: this.$auth.isSalesPerson ? false :  true
                },
                bankCode: {
                    required: this.$auth.isSalesPerson ? false :  true
                },
                pagBankEmail: {
                    required: false,
                    email: true
                },
                type: {
                    required: this.$auth.isSalesPerson ? false :  true
                }
            },
            bankList:[],
            bankAccountTypeList:[
                {
                    value: null,
                    text: 'Selecione'
                },
                {
                    value: 'CHECKING',
                    text: 'Conta-corrente'
                },
                {
                    value: 'SAVINGS',
                    text: 'Poupança'
                }
            ],
            sellerType: 'F'
        }
    },
    watch: {
        'value.document': function(newValue) {
            if(newValue != null) {
                this.value.documentType = newValue.length <= 11 ? 'F' : 'J'
            }                        
        },
        value() {
            this.$emit('input', this.value);
        }
    },
    computed: {
        isOwnerFieldsDisabled() {
            if(this.$auth.isSalesPerson || this.disabled || this.sellerType == 'F') {
                return true
            }
            return false
        }
    },
    created() {
        this.fechData()
        const self = this
        eventbus.$on('sellerInput:documentTypeChanged', function(value) {
            self.sellerType = value
        })
    },
    methods: {
        async fechData() {
            const self = this
            //self.showLoading()
            helperService.banksGetList().then((response) =>{
                self.bankList = response.status == 204 ? [] : response.data
                self.bankList.unshift({ COMPE: null, LongName: 'Selecione um banco'})
                //self.hideLoading()
            }, () => {
                //self.hideLoading()
            })
        },
        getError(fieldName) {
            return this.errors.first(fieldName)
        }
    }    
}
</script>